package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** SEO questions; also used for the FAQPage structured data. */
val SeoFaqs = listOf(
    RdText.SEO_FAQ1_Q to RdText.SEO_FAQ1_A,
    RdText.SEO_FAQ2_Q to RdText.SEO_FAQ2_A,
    RdText.SEO_FAQ3_Q to RdText.SEO_FAQ3_A,
    RdText.SEO_FAQ4_Q to RdText.SEO_FAQ4_A,
    RdText.SEO_FAQ5_Q to RdText.SEO_FAQ5_A,
)

@Composable
fun SeoFaqSection() {
    RdFaqBand(RdText.SEO_FAQ_TITLE, SeoFaqs)
}
